import { css } from '@emotion/css';

export const IMAGE_OPTION_WIDTH = 25.6;

export const imageStyles = css`
  width: ${IMAGE_OPTION_WIDTH}rem;
  height: 19.5rem;
  border-radius: 0.8rem;
  cursor: pointer;
`;
